<main class="h-full flex">
  <div
    class="hidden md:block md:w-2/4 bg-[url('../public/images/cover.png')] bg-no-repeat bg-center bg-cover"
  ></div>

  <!-- Título y subtitulo -->
  <div class="w-full md:w-2/4 flex items-center justify-center">
    <div class="w-full md:w-4/5 lg:w-3/5 xl:w-3/6 pt-5 px-5">
      <div class="text-center">
        <h1 class="text-5xl font-medium">
          Danzai <span class="font-light">Licencias</span>
        </h1>
        <p class="text-lg mt-5">Accede a la gestión de licencias.</p>
      </div>

      <!-- Formulario. -->
      <form [formGroup]="form" (ngSubmit)="login()" class="mt-10">
        <mat-form-field class="w-full">
          <mat-label>Nombre de usuario</mat-label>
          <input
            matInput
            type="text"
            name="username"
            formControlName="username"
          />
        </mat-form-field>
        <mat-form-field class="w-full">
          <mat-label>Contraseña</mat-label>
          <input
            matInput
            [type]="passwordHide ? 'password' : 'text'"
            name="password"
            formControlName="password"
          />
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="passwordHide = !passwordHide"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="passwordHide"
          >
            <mat-icon>{{
              passwordHide ? "visibility_off" : "visibility"
            }}</mat-icon>
          </button>
        </mat-form-field>
        @if (errors) { @for (error of errors; track error) {
        <p class="text-red-500 text-center">{{ error }}</p>
        } }
        <button mat-flat-button class="w-full mt-5" [disabled]="loading">
          Iniciar sesión
        </button>
      </form>
    </div>
  </div>
</main>

<!-- Pie de página. -->
<app-footer></app-footer>
